// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedLicensePartner {
  associatedPress: {"enum_constant":"associatedPress"};
}

export type LicensePartnerId = keyof IParsedLicensePartner;
export type LicensePartnerData = IParsedLicensePartner[LicensePartnerId];
const data: LicensePartnerData[] = [{"enum_constant":"associatedPress"}];
export default data;
